import { setVersionInEdicom } from '@edicom/common/edicom/setVersionInEdicom';
import { injectStyle } from '@edicom/common/tool/injectStyle';

import style from './index.css';

// worker
import ecFormBuilderWorker from './src/ec-form-builder.worker';

// core
import ecFormBuilder from './src/ec-form-builder.directive';
import ecFormBuilderCtrl from './src/ec-form-builder.controller';
import ecFormBuilderService from './src/ec-form-builder.service';

// Directivas
import fbCompileDirective from './src/directives/fb-compile/fb-compile.directive';
import fbHiddenDirective from './src/directives/fb-hidden/fb-hidden.directive';
import fbRegisterDirective from './src/directives/fb-register/fb-register.directive';
import fbRegisterMultipleDirective from './src/directives/fb-register/fb-register-multiple.directive';
import fbFlashDirective from './src/directives/fb-flash/fb-flash.directive';
import fbGridDirective from './src/directives/fb-grid/fb-grid.directive';
import fbGridPopupDirective from './src/directives/fb-grid/directives/fb-grid-popup.directive';
import fbListDirective from './src/directives/fb-list/fb-list.directive';
import fbTreeDirective from './src/directives/fb-tree/fb-tree.directive';
import fbScriptDirective from './src/directives/fb-script/fb-script.directive';
import fbScriptVariablesButton from './src/directives/fb-script/fb-script-variables-button.directive';
import fbErrorsDirective from './src/directives/fb-errors/fb-errors.directive';
import fbErrorsService from './src/directives/fb-errors/fb-errors.service';

// cells
import FbCellRendererClass from './src/directives/fb-grid/cells/fb-cell-renderer.class';
import FbCellEditorClass from './src/directives/fb-grid/cells/fb-cell-editor.class';

// servicios
import eventEmitterService from './src/service/event-emitter.service';
import dispatcherFactoryService from './src/service/dispatcher-factory.service';
import ElementEdicomClass from './src/service/ElementEdicom.class';
import engineService from './src/engine/engine.service';
import injectorService from './src/injector/injector.service';

// package
import { version, name } from './package.json';

// init global
const src = document.currentScript.src;

setVersionInEdicom(name, version);
window.edicom[name] = { src }; // src: usado en ecFormBuilderService.Validator

style && injectStyle(style, 'ec-form-builder-edicom');

angular
  .module('ecFormBuilderEdicom', [])
  .service('ecFormBuilderWorker', ecFormBuilderWorker)
  .directive('ecFormBuilder', ecFormBuilder)
  .controller('ecFormBuilderCtrl', ecFormBuilderCtrl)
  .service('ecFormBuilderService', ecFormBuilderService)
  .directive('fbCompile', fbCompileDirective)
  .directive('fbHidden', fbHiddenDirective)
  .directive('fbRegister', fbRegisterDirective)
  .directive('fbRegisterMultiple', fbRegisterMultipleDirective)
  .directive('fbGrid', fbGridDirective)
  .directive('fbGridPopup', fbGridPopupDirective)
  .service('FbCellRenderer', FbCellRendererClass)
  .service('FbCellEditor', FbCellEditorClass)
  .directive('fbTree', fbTreeDirective)
  .directive('fbList', fbListDirective)
  .directive('fbFlash', fbFlashDirective)
  .directive('fbScript', fbScriptDirective)
  .directive('fbScriptVariablesButton', fbScriptVariablesButton)
  .directive('fbErrors', fbErrorsDirective)
  .service('fbErrorsService', fbErrorsService)
  // service
  .service('eventEmitterService', eventEmitterService)
  .factory('dispatcherFactoryService', dispatcherFactoryService)
  .factory('ElementEdicom', ElementEdicomClass)
  // engine
  .service('engineService', engineService)
  .service('injectorService', injectorService);
